import { AztecHTLCPublicClient } from './PublicClient';
import { userLock } from './wallet/userLock';
import { refund } from './wallet/refund';
import { redeemSolver } from './wallet/redeemSolver';
import { buildUserLockTx } from './wallet/buildUserLockTx';
import { buildRefundTx } from './wallet/buildRefundTx';
import { buildRedeemSolverTx } from './wallet/buildRedeemSolverTx';
export class AztecHTLCWalletClient extends AztecHTLCPublicClient {
    constructor(config) {
        super(config);
    }
    // ── Write Operations ───────────────────────────────────────────────
    async userLock(params) {
        return userLock(this.signer, this.rpcUrl, params, this.getNode());
    }
    async refund(params) {
        return refund(this.signer, params, this.getNode());
    }
    async redeemSolver(params) {
        return redeemSolver(this.signer, this.rpcUrl, params, this.getNode());
    }
    // ── Transaction Builders ──────────────────────────────────────────
    // Return prepared `ContractFunctionInteraction`s ready to be batched
    // and submitted. Registering Train/Token contracts on the wallet is a
    // side effect — that's required by Aztec before `.at(...)` works.
    async buildUserLockTx(params) {
        return buildUserLockTx(this.signer, this.rpcUrl, params, this.getNode());
    }
    async buildRefundTx(params) {
        return buildRefundTx(this.signer, params, this.getNode());
    }
    async buildRedeemSolverTx(params) {
        return buildRedeemSolverTx(this.signer, this.rpcUrl, params, this.getNode());
    }
}
